import { useApiStatus } from "@common/hooks/useApiStatus"
import { DimensionsContext } from "@common/utils/mobileUtils"
import {
    audioRecordingStatus,
    pauseActivity,
} from "@data/redux/actions/activity"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { liveServiceV2 } from "@data/services/liveServiceV2"
import {
    addTimestampToField,
    addWorkAttachmentToField,
} from "@data/utility/Utils"
import React, { useContext, useEffect, useState } from "react"
import { useController } from "react-hook-form"
import { View } from "react-native"
import { connect } from "react-redux"
import { AudioRecordingContainer } from "./AudioRecordingContainer"

const AudioVideoActivityStep = (props) => {
    // ** Component props
    const {
        stepData,
        stepIndex,
        control,
        status,
        setStatus,
        finishStep,
        recordingURI,
        setRecordingURI,
        style,
        hideModal = () => {},
    } = props

    const [time, setTime] = useState(0)

    const roomVersion = props.user.live_sessions?.find(
        (l) => l?.id === props.liveSessionId
    )?.live_room?.version

    const setVoiceRecordingActivityApi =
        liveServiceV2.setVoiceRecordingActivityV2

    // ** Form field
    const { field: activityLogsField } = useController({
        control,
        name: "activity_logs",
    })
    const { field: workAttachmentLogsField } = useController({
        control,
        name: "work_attachment_logs",
    })

    useEffect(() => {
        // Enable Voice recording activity
        if (props.liveSessionId)
            props.apiRequest(
                setVoiceRecordingActivityApi,
                { id: props.liveSessionId },
                { enabled: true }
            )
        const workAttachment = workAttachmentLogsField?.value?.find(
            (log) =>
                log?.action === "step_media_sent" && log?.step === stepIndex + 1
        )

        if (!workAttachment) {
            // Update field to be sent to server
            addTimestampToField(
                activityLogsField,
                stepIndex + 1,
                "step_started"
            )
        } else if (stepData?.length !== 0) {
            setRecordingURI(workAttachment?.work_attachment?.uri)
        }
    }, [])

    useApiStatus(
        setVoiceRecordingActivityApi, // api service
        null, // success message on toast (string or null)
        false, // error message on toast (true) or keep it in redux state (false)
        () => {} // success callback
    )

    useEffect(() => {
        if (
            status !== "finished" &&
            !!recordingURI &&
            recordingURI !==
                workAttachmentLogsField.value?.[0]?.work_attachment?.uri
        ) {
            addWorkAttachmentToField(
                workAttachmentLogsField,
                stepIndex + 1,
                [{ uri: recordingURI }],
                props?.user?.id,
                "m4a"
            )
        }
    }, [recordingURI])
    useEffect(() => {
        if (props.activityPaused) props.pauseActivity(false)
    }, [])
    const dimensions = useContext(DimensionsContext)

    useEffect(() => {
        if (status === "finished" && !!recordingURI) {
            finishStep()
            addTimestampToField(
                activityLogsField,
                stepIndex + 1,
                "step_finished",
                {
                    chrono_duration: time,
                }
            )
            if (props.liveSessionId)
                props.apiRequest(
                    setVoiceRecordingActivityApi,
                    { id: props.liveSessionId },
                    { enabled: false }
                )
        }
    }, [status])
    return (
        <View
            style={{
                width: dimensions?.width,
                paddingTop: 4,
                alignItems: "center",
                alignContent: "flex-start",
                justifyContent: "flex-start",
                paddingHorizontal: 15,
                ...style,
            }}
        >
            <AudioRecordingContainer
                status={status}
                setTime={setTime}
                recordingURI={recordingURI}
                setRecordingURI={setRecordingURI}
                activityPaused={props.activityPaused}
                audioRecordingStatus={props.audioRecordingStatus}
                hideModal={hideModal}
                setStatus={setStatus}
            />
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        activityPaused: state.activity?.activityPaused,
        liveSessionId: state.liveMode?.liveSessionId,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    pauseActivity,
    audioRecordingStatus,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AudioVideoActivityStep)
